import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';
import { Shield, Flame, Zap, Sparkles } from 'lucide-react';

const BUNDLES = [
  { icon: Shield, title: 'Inventory + EICR', desc: 'Comprehensive property documentation with electrical safety certification.', saving: '10% off Inventory' },
  { icon: Flame, title: 'Inventory + Gas Safety', desc: 'Full inventory report paired with annual gas safety check.', saving: '10% off Inventory' },
  { icon: Zap, title: 'Inventory + EPC', desc: 'Property condition report with energy performance certification.', saving: '10% off Inventory' },
  { icon: Sparkles, title: 'Inventory + EOT Cleaning', desc: 'Full inventory report paired with professional end-of-tenancy deep cleaning.', saving: '10% off Inventory' },
];

export default function BundleSection() {
  return (
    <section className="py-16 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center mb-16">
            <p className="caps-label text-orange mb-4">Bundle &amp; Save</p>
            <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Save 10% on inventory when you bundle
            </h2>
            <p className="text-lg text-muted-foreground mt-4 max-w-2xl mx-auto">
              Book any inventory service alongside a safety certificate or end-of-tenancy cleaning and automatically receive 10% off your inventory report.
            </p>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BUNDLES.map((bundle, i) => (
            <ScrollReveal key={bundle.title} delay={i * 0.1}>
              <div className="border border-navy/10 p-10 hover:border-orange transition-colors h-full">
                <bundle.icon className="text-orange mb-6" size={32} />
                <h3 className="text-xl font-semibold text-navy mb-3">{bundle.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-6">{bundle.desc}</p>
                <p className="caps-label text-orange bg-orange/10 inline-block px-3 py-1.5 rounded-full">{bundle.saving}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
        <ScrollReveal delay={0.3}>
          <div className="text-center mt-12">
            <Link to="/book-now" className="inline-block px-8 py-4 bg-orange text-navy font-semibold rounded-full hover:bg-orange-dark transition-colors">
              Build Your Bundle
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}